//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TagFilter from '@/views/personal_package/_feedback/_tag_filter'
import tag_mixins from '@/views/personal_package/_feedback/mixins'
import WX_API from '@/utils/wx_api'
import FeedbackService from './service'
import Service from '@/service'
const checkForm = (values) => {
    const checkRequired = value => typeof value === 'string' && Boolean(value.trim())
    const rules = {
        category: {
            check: checkRequired,
            text: '请选择反馈类型'
        },
        content: {
            check: checkRequired,
            text: '请填写问题描述'
        },
    }
    return Object.keys(rules).every((field) => {
        const rule = rules[field]
        if (rule.check(values[field] ,values)) {
            return true
        }
        wx.showToast({
            title: rule.text,
            duration: 2000,
            icon: 'none'
        })
        return false
    })
}
const STATUS = {
    UPLOADING: 'uploading',
    FAIL: 'fail',
    SUCCESS: 'success'
}

const BUILDING_LIST = ['building', 'building_info', 'around_facilities']
const BUILDING_SCENE = {
    'building': '楼盘详情信息纠错',
    'building_info': '楼盘详情-楼盘详情信息纠错',
    'around_facilities': '周边配套'
}

export default {
    mixins: [ tag_mixins ],
    data() {
        return {
            params: {
                category: '',
                content: '',
                contact: '',
                photos_urls: [],
            },
            temp_imgs: [],
            img_count: 3,
            building_id: '',
            from: ''
        }
    },
    components: {
        TagFilter
    },
    onShareAppMessage() {
        const sub_path = encodeURIComponent(`/pages/personal_package/feedback/main`)
        const shareOpt = {
            title: '点这提交反馈哦，欢迎您对购房通提出建议和意见~',
            path: `/pages/index/main?sub_page=${sub_path}`
        }
        return this.getShareInfo(shareOpt)
    },
    async mounted ({ from, building_id, category }) {
        if (from) {
            this.from = from
        }
        if (building_id) {
            this.building_id = building_id
        }
        if (category) {
            this.changeStatus(category)
        }
        await Service.init()
        await this.initTags()
    },
    methods: {
        changeStatus(category) {
            this.params.category = category
        },
        handleUploadStatus (i, url, success) {
            this.temp_imgs[i].status = success ? STATUS.SUCCESS : STATUS.FAIL
            this.temp_imgs[i].uploaded_url = url
            const finished = this.temp_imgs.every(({ status }) => status != STATUS.UPLOADING)
            if (finished) {
                wx.hideLoading()
            }
        },
        async uploadImg (e) {
            const photos_urls_len = this.temp_imgs.length
            const count = this.img_count - photos_urls_len
            const tempFiles = await WX_API.chooseImage({
                count,
                sourceType: ['album'],
            })
            const new_imgs = tempFiles.map((url) => {
                return {
                    url,
                    status: STATUS.UPLOADING,
                    uploaded_url: ''
                }
            })
            const uploaded_len = this.temp_imgs.length
            this.temp_imgs.push(...new_imgs)
            wx.showLoading({
                title: '上传中',
                mask: true
            })
            tempFiles.forEach((file, i) => {
                WX_API.uploadImg(file).then(url => {
                    this.handleUploadStatus(uploaded_len + i, url, true)
                }).catch((error) => {
                    this.handleUploadStatus(uploaded_len + i, '', false)
                })
            })
        },
        previewImg (i) {
            wx.previewImage({
                current: this.temp_imgs[i].url,
                urls: this.temp_imgs.map(({url}) => url),
            })
        },
        removeImg (index) {
            this.temp_imgs.splice(index, 1)
        },
        async submit() {
            const params = {
                ...this.params,
                photos_urls: this.temp_imgs
                    .filter(({ status }) => status === STATUS.SUCCESS)
                    .map(({ uploaded_url }) => uploaded_url)
            }
            if (this.consultant_call) {
                params.category = '其他'
                params.targetable_type = 'Fc::Consultant'
                params.targetable_id = this.consultant_call.consultant.id
            }
            if (BUILDING_LIST.indexOf(this.from) > -1) {
                params.targetable_type = 'Fc::Building'
                params.targetable_id= this.building_id
                params.scene = BUILDING_SCENE[this.from]
            }
            const canSubmit = checkForm(params)
            console.error(params)
            if (canSubmit) {
                const res = await FeedbackService.setFeedbacks(params)
                if (res.code === 422) {
                    wx.showToast({
                        title: res.error_message,
                        icon: 'none'
                    })
                    return
                }
                wx.showToast({
                    title: '提交成功'
                })
                setTimeout(()=> {
                    if (getCurrentPages().length > 1) {
                        wx.navigateBack({
                            delta: 1
                        })
                    } else {
                        wx.switchTab({
                            url: '/pages/personal_center/main'
                        })
                    }
                }, 1500)
            }
        }
    }
}
